import { Component, effect, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { Stakeholder } from '../../../stakeholder/models/stakeholder';
import { ErrorRuleActions } from '../../models/error-rule-actions';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';
import { PartnerContactType } from 'src/app/partner/models';
import { LayoutRowComponent } from '../../../controls/components/basic/layout-row/layout-row.component';
import { LayoutColumnComponent } from '../../../controls/components/basic/layout-column/layout-column.component';
import { SingleselectboxComponent } from '../../../controls/components/basic/singleselectbox/singleselectbox.component';
import { CheckboxComponent } from '../../../controls/components/basic/checkbox/checkbox.component';
import { TextboxComponent } from '../../../controls/components/basic/textbox/textbox.component';

@Component({
    selector: 'app-error-rules-actions',
    templateUrl: './error-rules-actions.component.html',
    styleUrls: ['./error-rules-actions.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, LayoutRowComponent, LayoutColumnComponent, SingleselectboxComponent, CheckboxComponent, TextboxComponent]
})
export class ErrorRulesActionsComponent {
  stakeholders = input.required<Stakeholder[]>();
  contactTypes = input.required<PartnerContactType[]>();
  actions = model<ErrorRuleActions>();
  onSummaryChange = output<string>();

  notifySenderPartner: boolean = false;
  notifyReceiverPartner: boolean = false;
  reassign: boolean = false;

  constructor() {
    effect(() => {
      this.notifySenderPartner = this.actions().NotifySenderPartnerContactTypeId != null ? true :  this.notifySenderPartner;
      this.notifyReceiverPartner = this.actions().NotifyReceiverPartnerContactTypeId != null ? true : this.notifyReceiverPartner;
      this.reassign = this.actions().ReassignToErrorCode != null ? true : this.reassign;
    });

    effect(() => {
      const sendingPartnerContactType = this.contactTypes()?.find(c => c.Id == this.actions()?.NotifySenderPartnerContactTypeId)?.Name
      const receivingPartnerContactType = this.contactTypes()?.find(c => c.Id == this.actions()?.NotifyReceiverPartnerContactTypeId)?.Name
      const reassignToErrorCode = this.actions().ReassignToErrorCode
      const notifyStakeholder = this.actions().NotifyStakeholder
      const notifyStakeholderUrgent = this.actions().NotifyStakeholderUrgent
      const setIgnoredStatus = this.actions().SetIgnoredStatus

      var notifyStakeholderStr = null;
      if (notifyStakeholder) {
        notifyStakeholderStr = "Notify Stakeholder"
      }

      var notifyStakeholderUrgentStr = null;
      if (notifyStakeholderUrgent) {
        notifyStakeholderUrgentStr = "Notify Stakeholder Urgent"
      }

      var sendingPartnerStr = null;
      if (sendingPartnerContactType) {
        sendingPartnerStr = "Notify Sending Partner" + " (" + sendingPartnerContactType + ")";
      }

      var receivingPartnerStr = null;
      if (receivingPartnerContactType) {
        receivingPartnerStr = "Notify Receiving Partner" + " (" + receivingPartnerContactType + ")";
      }

      var reassignStr = null;
      if (reassignToErrorCode) {
        reassignStr = "Reassign to error code" + " \"" + reassignToErrorCode + "\""
      }

      var setIgnoredStatusStr = null;
      if (setIgnoredStatus) {
        setIgnoredStatusStr = "Set status to Ignored"
      }

      const actionStrings = [notifyStakeholderStr, notifyStakeholderUrgentStr, sendingPartnerStr, receivingPartnerStr, reassignStr, setIgnoredStatusStr];

      const summary = actionStrings.filter(Boolean).join(" and ");
      this.onSummaryChange.emit(summary);
    });
  }

  onStakeholderChange(value: string) {
  }

  onNotifyStakeholderChange(value: boolean) {
    this.actions.update(a => ({...a, NotifyStakeholder: value}));
  }

  onNotifyStakeholderUrgentChange(value: boolean) {
    this.actions.update(a => ({...a, NotifyStakeholderUrgent: value}));
  }

  onNotifySenderContactChange(value: number) {
    this.actions.update(a => ({...a, NotifySenderPartnerContactTypeId: value}));
  }
  
  onNotifyReceiverContactChange(value: number) {
    this.actions.update(a => ({...a, NotifyReceiverPartnerContactTypeId: value}));
  }

  onReassignErrorCodeChange(value: string) {
    this.actions.update(a => ({...a, ReassignToErrorCode: value}));
  }

  onSetIgnoreChange(value: boolean) {
    this.actions.update(a => ({...a, SetIgnoredStatus: value}));
  }

  onNotifySenderChange(value: boolean) {
    if (value === false) {
      this.actions.update(a => ({...a, NotifySenderPartnerContactTypeId: null}));
    }
  }

  onNotifyReceiverChange(value: boolean) {
    if (value === false) {
      this.actions.update(a => ({...a, NotifyReceiverPartnerContactTypeId: null}));
    }
  }

  onReassignChange(value: boolean) {
    if (value === false) {
      this.actions.update(a => ({...a, ReassignToErrorCode: null}));
    }
  }
}
